import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet, apiPost, apiPut } from "../../../API/Api_Url";
import {
    Home,
    Users,
    DollarSign,
    Clock,
    Calendar,
    FileCheck,
    X,
    UserCheck,
    Locate,
    User,
    MapPin,
    MoreVertical,
    Trash,
    Edit,
} from "lucide-react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import { BiMoney } from "react-icons/bi";
import ContractorAddTrackerModal from "../../Modal/ContractorAddTrackerModal";
import ContractorUpdateTrackerModal from "../../Modal/ContractorUpdateTrackerModal";
import ContractorDeleteTrackerModal from "../../Modal/ContractorDeleteTrackerModal";
import ContractorDeleteBidModel from "../../Modal/ContractorDeleteBidModel";
import ContractorUpdateBidModel from "../../Modal/ContractorUpdateBidModel";
import ContractorCreateBidModel from "../../Modal/ContractorCreateBidModel";

function AllAssignedConstructionRequirements() {
    const navigate = useNavigate();
    const [Requirements, setRequirements] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const GetAllAssignRequirement = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet(
                "api/contractor/GetAllMyAssignedRequirements"
            );
            setRequirements(response.data || []);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        GetAllAssignRequirement();
    }, []);

    const [IsLoading, setIsLoading] = useState(false);

    const GenerateAgreementRequests = async (id) => {
        try {
            setIsLoading(true);
            const payload = {};

            const response = await apiPost(`api/contractor/GenerateAgreementRequests/${id}`, payload);

            if (response?.data) {
                toast.success(response?.message || "Bid submitted successfully!");
                GetAllAssignRequirement();
            } else {
                toast.error(response?.message || "Failed to submit bid");
            }
        } catch (error) {
            console.error("Error submitting bid:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const [AllTracker, setAllTracker] = useState([]);


    const fetchAllTracker = async (id) => {
        try {
            setIsLoading(true);
            const response = await apiGet(`api/contractor/GetARequirementTracking/${id}`);
            setAllTracker(response?.data || []);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Error fetching data:", error);
        }
    };


    const [expandedrequirement, setExpandedrequirement] = useState(null);

    const toggleTracker = async (reqId) => {
        if (expandedrequirement === reqId) {
            setExpandedrequirement(null);
            setAllTracker([]);
        } else {
            await fetchAllTracker(reqId);
            setExpandedrequirement(reqId);
        }
    };

    const [showMenu, setShowMenu] = useState(false);
    const [openComments, setOpenComments] = useState({});

    const toggleComments = (id) => {
        setOpenComments((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };


    const [AddTrackerModel, setAddTrackerModel] = useState(false);
    const [selectedreq, setselectedreq] = useState(null);

    const OpenAddTrackerModel = (req) => {
        setAddTrackerModel(true)
        setselectedreq(req)
    }
    const CloseAddTrackerModel = () => {
        setAddTrackerModel(false)
        setselectedreq(null)
    }

    const [IsUpdateTrackerOpen, setIsUpdateTrackerOpen] = useState(false);
    const [SelectedTracker, setSelectedTracker] = useState(null);

    const OpenUpdateTrackerModel = (Tracker) => {
        setShowMenu(null)
        setSelectedTracker(Tracker)
        setIsUpdateTrackerOpen(true)
    }

    const CloseUpdateTrackerModel = () => {
        setSelectedTracker(null)
        setShowMenu(null)
        setIsUpdateTrackerOpen(false)
    }


    const [IsDeleteTrackerOpen, setIsDeleteTrackerOpen] = useState(false);

    const OpenDeleteTrackerModel = (Tracker) => {
        setSelectedTracker(Tracker)
        setShowMenu(null)
        setIsDeleteTrackerOpen(true)
    }

    const CloseDeleteTrackerModel = () => {
        setSelectedTracker(null)
        setShowMenu(null)
        setIsDeleteTrackerOpen(false)
    }


    const [Quotation, setQuotation] = useState(null);
    const [QuotationError, setQuotationError] = useState(null);
    const [IsQuotationLoading, setIsQuotationLoading] = useState(false);

    const GetQuotationofAJobPost = async (id) => {
        try {
            setIsQuotationLoading(true);
            setQuotation(null);
            setQuotationError(null);

            const response = await apiGet(`api/contractor/GetMyBidRequirement/${id}`);

            if (response?.statusCode === 200) {
                setQuotation(response?.data);
            } else {
                setQuotationError(response?.message || "No Quotation found");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setQuotationError("Error fetching Quotation");
        } finally {
            setIsQuotationLoading(false);
        }
    };



    const [expandedJob, setExpandedJob] = useState(null);

    const toggleQuotations = async (reqId) => {
        if (expandedJob === reqId) {
            setExpandedJob(null);
            setQuotation(null);
            setQuotationError(null);
        } else {
            await GetQuotationofAJobPost(reqId);
            setExpandedJob(reqId);
        }
    };

    const [SelectedQuotation, setSelectedQuotation] = useState(null);
    const [UpdateQuotationModel, setUpdateQuotationModel] = useState(false);

    const OpenUpdateQuotationModel = (req) => {
        setUpdateQuotationModel(true)
        setSelectedQuotation(req)
    }

    const CloseUpdateQuotationModel = () => {
        setUpdateQuotationModel(false)
        setSelectedQuotation(null)
    }

    const [DeleteQuotationModel, setDeleteQuotationModel] = useState(false);

    const OpendeleteQuotationModel = (req) => {
        setSelectedQuotation(req)
        setDeleteQuotationModel(true)
    }

    const CloseDeleteQuotationModel = () => {
        setDeleteQuotationModel(false)
        setSelectedQuotation(null)
    }


    const [AddQuotationModel, setAddQuotationModel] = useState(false);
    const [SelectedReq, setSelectedReq] = useState(null);

    const OpenAddQuotationModel = (req) => {
        setSelectedReq(req)
        setAddQuotationModel(true)
    }

    const CloseAddQuotationModel = () => {
        setSelectedReq(null)
        setAddQuotationModel(false)
    }



    const getStatusColor = (status) => {
        switch (status) {
            case "Pending":
                return "bg-yellow-100 text-yellow-800 border-yellow-200";
            case "Approved":
            case "UserApproved":
                return "bg-green-100 text-green-800 border-green-200";
            case "Rejected":
                return "bg-red-100 text-red-800 border-red-200";
            default:
                return "bg-gray-100 text-gray-800 border-gray-200";
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };

    const formatMaskedAddress = (ur) => {
        const address = ur?.Location?.Address || "";
        const city = ur?.City || "";
        const state = ur?.State || "";
        const pincode = ur?.Pincode || "";

        let maskedAddress = address;
        if (address.length > 8) {
            maskedAddress =
                address?.substring(0, 5) +
                "****" +
                address.substring(address?.length - 10);
        }

        return `${maskedAddress}, ${city}, ${state} - ${pincode}`;
    };

    const maskString = (str, visibleStart = 2, visibleEnd = 2) => {
        if (!str) return "";
        if (str.length <= visibleStart + visibleEnd) return str;
        return (
            str.substring(0, visibleStart) +
            "****" +
            str.substring(str.length - visibleEnd)
        );
    };

    const formatMaskedUser = (user) => {
        const name = maskString(user?.name, 1, 1);
        const email = user?.email
            ? maskString(user?.email.split("@")[0], 2, 2) + "@" + user?.email.split("@")[1]
            : "";
        const phone = maskString(user?.phone, 2, 2);

        return `👤 ${name} | ✉️ ${email} | 📞 ${phone}`;
    };

    const ImageModal = () => {
        if (!selectedImage) return null;

        return (
            <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
                <div className="relative max-w-4xl max-h-full">
                    <button
                        onClick={() => setSelectedImage(null)}
                        className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors"
                    >
                        <X size={32} />
                    </button>
                    <img
                        src={selectedImage}
                        alt="Construction site"
                        className="max-w-full max-h-screen object-contain rounded-lg"
                    />
                </div>
            </div>
        );
    };

    const ImageGallery = ({ images }) => {
        if (!images || images.length === 0) return null;

        return (
            <div className="mb-4">
                {images.length === 1 ? (
                    <img
                        src={images[0]}
                        alt="Project"
                        className="h-48 w-full object-cover rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
                        onClick={() => setSelectedImage(images[0])}
                    />
                ) : (
                    <div className="grid grid-cols-2 gap-2">
                        {images?.slice(0, 4).map((image, index) => (
                            <div key={index} className="relative">
                                <img
                                    src={image}
                                    alt={`Project ${index + 1}`}
                                    className={`w-full object-cover rounded-lg cursor-pointer hover:opacity-90 transition-opacity ${index === 0 ? 'h-32' : 'h-20'
                                        }`}
                                    onClick={() => setSelectedImage(image)}
                                />
                                {index === 3 && images?.length > 4 && (
                                    <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center text-white font-semibold">
                                        +{images?.length - 4} more
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };


    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <h1 className="text-3xl font-bold text-gray-900 mb-6">
                    All My Assigned Construction Requirements
                </h1>

                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading assigned requirements...</p>
                    </div>
                ) : Requirements?.length === 0 ? (
                    <div className="text-center py-20">
                        <Home className="mx-auto h-16 w-16 text-gray-400 mb-4" />
                        <p className="text-xl text-gray-500">No assigned requirements found.</p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {Requirements?.map((req) => (
                            <div
                                key={req?._id}
                                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden"
                            >
                                <ImageGallery images={req?.SitePhotosOrPlan} />
                                <div className="p-6 space-y-4">
                                    <div className="flex justify-between items-center">
                                        <h3 className="text-xl font-bold text-gray-900">
                                            {req?.ProjectType}
                                        </h3>
                                        <span
                                            className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(
                                                req?.Status
                                            )}`}
                                        >
                                            {req?.Status}
                                        </span>
                                    </div>
                                    {["InConstruction", "Completed", "Rebid"]?.includes(req?.Status) ? (
                                        <>
                                            <div className="flex items-start text-gray-600 mb-4">
                                                <MapPin className="flex-shrink-0 h-4 w-4 mr-2 mt-0.5" />
                                                <p className="text-sm">
                                                    <a
                                                        href={`https://www.google.com/maps?q=${req?.Location?.Late},${req?.Location?.Long}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 hover:underline"
                                                    >
                                                        {req?.Location?.Address}, {req?.City}, {req?.State} - {req?.Pincode}
                                                    </a>
                                                </p>
                                            </div>
                                            <div className="flex items-start text-gray-600 mb-4">
                                                <User className="flex-shrink-0 h-4 w-4 mr-2 mt-0.5" />
                                                <p className="text-sm">
                                                    {req?.User?.name} ({req?.User?.email}) - {req?.User?.phone}
                                                </p>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <p className="text-sm bg-gray-100 px-3 py-3 rounded-md text-gray-600 italic">
                                                Location - {formatMaskedAddress(req)}
                                            </p>
                                            <p className="text-sm bg-gray-100 px-3 py-3 rounded-md text-gray-600 italic">
                                                User - {formatMaskedUser(req?.User)}
                                            </p>
                                        </>
                                    )}
                                    <div className="grid grid-cols-2 md:grid-cols-2 gap-4 text-sm">
                                        <div className="flex items-start gap-2 text-gray-700">
                                            <Home className="h-4 w-4 text-blue-500 mt-0.5" />
                                            <div>
                                                <p className="font-medium">Size</p>
                                                <p className="text-gray-600">
                                                    {req?.SizeDimension?.Length} x{" "}
                                                    {req?.SizeDimension?.Breadth} x {req?.NumberOfFloors} (
                                                    {req?.SizeDimension?.Area})
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-2 text-gray-700">
                                            <Users className="h-4 w-4 text-green-500 mt-0.5" />
                                            <div>
                                                <p className="font-medium">Floors</p>
                                                <p className="text-gray-600">{req?.NumberOfFloors}</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-2 text-gray-700">
                                            <DollarSign className="h-4 w-4 text-purple-500 mt-0.5" />
                                            <div>
                                                <p className="font-medium">Budget</p>
                                                <p className="text-gray-600">{req?.Budget}</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-2 text-gray-700">
                                            <Clock className="h-4 w-4 text-orange-500 mt-0.5" />
                                            <div>
                                                <p className="font-medium">Timeline</p>
                                                <p className="text-gray-600">
                                                    {req?.TimelineInMonths} months
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-2 text-gray-700">
                                            <FileCheck className="h-4 w-4 text-purple-500 mt-0.5" />
                                            <div>
                                                <p className="font-medium">Admin Agreement Status</p>
                                                <p className="text-gray-600">{req?.AdminAgreementRequest}</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-2 text-gray-700">
                                            <UserCheck className="h-4 w-4 text-orange-500 mt-0.5" />
                                            <div>
                                                <p className="font-medium">User Agreement Status</p>
                                                <p className="text-gray-600">
                                                    {req?.UserAgreementRequest}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-2 text-gray-700">
                                            <BiMoney className="h-4 w-4 text-purple-500 mt-0.5" />
                                            <div>
                                                <p className="font-medium">Payment Method</p>
                                                <p className="text-gray-600">{req?.PaymentMethod}</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-2 text-gray-700">
                                            <Locate className="h-4 w-4 text-orange-500 mt-0.5" />
                                            <div>
                                                <p className="font-medium">Site Visit</p>
                                                <p className="text-gray-600">
                                                    {req?.SiteVisit ? "Yes" : "No"}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {req?.RequirementHistory && req?.RequirementHistory.length > 0 && (
                                    <div className="mt-4 p-4 bg-gray-50 border border-gray-200 rounded-lg space-y-2">
                                        <h4 className="text-md font-semibold text-gray-800 mb-2">Requirement History</h4>
                                        {req?.RequirementHistory.map((history) => (
                                            <div
                                                key={history?._id}
                                                className="p-2 bg-white rounded-md shadow-sm border border-gray-100 text-sm"
                                            >
                                                <p className="text-gray-600 mb-1">
                                                    <span className="font-medium">Changed At:</span>{" "}
                                                    {new Date(history?.createdAt).toLocaleString()}
                                                </p>

                                                <div className="grid grid-cols-2 gap-2 text-gray-700">
                                                    <div className="bg-gray-50 p-2 rounded">
                                                        <p className="font-medium text-gray-600 mb-1">Old Data</p>
                                                        {history?.OldData?.SizeDimension && (
                                                            <p>Size: {history.OldData.SizeDimension.Length} x {history.OldData.SizeDimension.Breadth}</p>
                                                        )}
                                                        {history?.OldData?.NumberOfFloors !== undefined && (
                                                            <p>Floors: {history.OldData.NumberOfFloors}</p>
                                                        )}
                                                    </div>
                                                    <div className="bg-gray-50 p-2 rounded">
                                                        <p className="font-medium text-gray-600 mb-1">New Data</p>
                                                        {history?.NewData?.SizeDimension && (
                                                            <p>Size: {history.NewData.SizeDimension.Length} x {history.NewData.SizeDimension.Breadth}</p>
                                                        )}
                                                        {history?.NewData?.NumberOfFloors !== undefined && (
                                                            <p>Floors: {history.NewData.NumberOfFloors}</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <div className="px-6 py-4 bg-gray-50 border-t flex flex-wrap justify-between items-center gap-3">
                                    <div className="flex items-center text-sm text-gray-500">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        <span>Created: {formatDate(req?.createdAt)}</span>
                                    </div>

                                    {req?.NeedLocalAuthorityApproval && (
                                        <div className="flex items-center text-sm text-red-600 font-medium">
                                            <FileCheck className="h-4 w-4 mr-1" />
                                            <span>Authority Approval</span>
                                        </div>
                                    )}

                                    {req?.AdminAgreementRequest === "NotGenerated" &&
                                        req?.UserAgreementRequest === "NotGenerated" &&
                                        req?.Status !== 'Rebid' && (
                                            <button
                                                disabled={IsLoading}
                                                onClick={() => GenerateAgreementRequests(req?._id)}
                                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md shadow"
                                            >
                                                {IsLoading ? 'Please Wait' : 'Generate Agreement'}
                                            </button>
                                        )}
                                    {req?.Status === "InConstruction" &&
                                        <button
                                            onClick={() => toggleTracker(req?._id)}
                                            className="text-sm text-blue-600 hover:underline flex items-center gap-2 disabled:opacity-50"
                                            disabled={IsLoading}
                                        >
                                            {IsLoading && expandedrequirement === req?._id ? (
                                                <>
                                                    <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                                    <span>Loading...</span>
                                                </>
                                            ) : expandedrequirement === req?._id ? (
                                                "Hide All Tracker"
                                            ) : (
                                                "Show All Tracker"
                                            )}
                                        </button>
                                    }
                                    {(req?.Status === "InConstruction" || req?.Status === "Rebid") &&
                                        <button
                                            onClick={() => toggleQuotations(req?._id)}
                                            className="text-sm text-blue-600 hover:underline flex items-center gap-2 disabled:opacity-50"
                                            disabled={IsQuotationLoading}
                                        >
                                            {IsQuotationLoading && expandedJob === req?._id ? (
                                                <>
                                                    <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                                    <span>Loading...</span>
                                                </>
                                            ) : expandedJob === req?._id ? (
                                                "Hide My Quotations"
                                            ) : (
                                                "Show My Quotations"
                                            )}
                                        </button>
                                    }
                                </div>
                                {expandedrequirement === req?._id && (
                                    <div className="p-6 border-t space-y-4 bg-gray-50">
                                        {req?.Status === "InConstruction" &&
                                            <button
                                                disabled={IsLoading}
                                                onClick={() => OpenAddTrackerModel(req)}
                                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md shadow"
                                            >
                                                Add Tracker
                                            </button>
                                        }
                                        {AllTracker?.length > 0 ? (
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                {AllTracker?.map((tracker, idx) => (
                                                    <div
                                                        key={tracker?._id || idx}
                                                        className="border border-gray-200 rounded-2xl p-6 bg-white shadow-sm hover:shadow-md transition"
                                                    >
                                                        <div className="flex justify-between items-center mb-4">
                                                            <h4 className="text-lg font-semibold text-gray-900">{tracker?.Title}</h4>
                                                            <span
                                                                className={`px-3 py-1 text-xs font-semibold rounded-full shadow-sm ${getStatusColor(
                                                                    tracker?.Status
                                                                )}`}
                                                            >
                                                                {tracker?.Status}
                                                            </span>

                                                            <div className="relative">
                                                                <button
                                                                    className="p-2 rounded-full hover:bg-gray-100"
                                                                    onClick={() =>
                                                                        setShowMenu((prev) => (prev === tracker?._id ? null : tracker?._id))
                                                                    }
                                                                >
                                                                    <MoreVertical size={18} />
                                                                </button>

                                                                {showMenu === tracker?._id && (
                                                                    <div className="absolute right-0 mt-2 w-36 bg-white border rounded-lg shadow-lg overflow-hidden z-10">
                                                                        <button
                                                                            className="w-full px-4 py-2 flex items-center gap-2 hover:bg-gray-50 text-sm"
                                                                            onClick={() => {
                                                                                OpenUpdateTrackerModel(tracker);
                                                                            }}
                                                                        >
                                                                            <Edit size={14} /> Update
                                                                        </button>
                                                                        <button
                                                                            className="w-full px-4 py-2 flex items-center gap-2 hover:bg-red-50 text-red-600 text-sm"
                                                                            onClick={() => {
                                                                                OpenDeleteTrackerModel(tracker);
                                                                            }}
                                                                        >
                                                                            <Trash size={14} /> Delete
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 text-sm text-gray-700 mb-4">
                                                            <p>
                                                                <span className="font-medium">📄 Description:</span> {tracker?.Description}
                                                            </p>
                                                            <p>
                                                                <span className="font-medium">⏳ Start Date:</span> {tracker?.StartDate}
                                                            </p>
                                                            <p>
                                                                <span className="font-medium">✅ End Date:</span> {tracker?.EndDate}
                                                            </p>
                                                            <p>
                                                                <span className="font-medium">🕒 Created:</span> {formatDate(tracker?.createdAt)}
                                                            </p>
                                                        </div>
                                                        {tracker?.Media?.length > 0 && (
                                                            <div className="mt-4">
                                                                <p className="text-sm font-semibold text-gray-800 mb-2">📸 Media</p>
                                                                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                                                    {tracker?.Media?.map((media, mediaIdx) => (
                                                                        <div
                                                                            key={media?._id || mediaIdx}
                                                                            className="relative group overflow-hidden rounded-lg shadow"
                                                                        >
                                                                            {media?.FileType === "image" ? (
                                                                                <img
                                                                                    src={media?.FileUrl}
                                                                                    alt="Tracker media"
                                                                                    className="w-full h-32 object-cover rounded-lg transform group-hover:scale-105 transition duration-300"
                                                                                />
                                                                            ) : media?.FileType === "video" ? (
                                                                                <video
                                                                                    src={media?.FileUrl}
                                                                                    controls
                                                                                    className="w-full h-32 object-cover rounded-lg bg-black"
                                                                                />
                                                                            ) : (
                                                                                <div className="w-full h-32 flex items-center justify-center bg-gray-200 text-gray-500 rounded-lg text-sm">
                                                                                    Unsupported file
                                                                                </div>
                                                                            )}
                                                                            <p className="text-xs text-gray-500 mt-1">
                                                                                Uploaded: {formatDate(media?.UploadedAt)}
                                                                            </p>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="mt-6">
                                                            <button
                                                                onClick={() => toggleComments(tracker?._id)}
                                                                className="text-sm font-semibold text-blue-600 hover:underline"
                                                            >
                                                                {openComments[tracker?._id]
                                                                    ? "Hide Comments"
                                                                    : `View Comments (${tracker?.Comments?.length || 0})`}
                                                            </button>

                                                            {openComments[tracker?._id] && (
                                                                <>
                                                                    <p className="text-sm font-semibold text-gray-800 mt-3 mb-2">💬 Comments</p>
                                                                    {tracker?.Comments?.length > 0 ? (
                                                                        <div className="space-y-3">
                                                                            {tracker?.Comments?.map((comment, commentIdx) => (
                                                                                <div
                                                                                    key={commentIdx}
                                                                                    className="bg-blue-50 border border-blue-100 p-3 rounded-lg text-sm text-gray-700 shadow-sm"
                                                                                >
                                                                                    <p>{comment?.CommentText}</p>
                                                                                    <p className="text-xs text-gray-500 mt-1">
                                                                                        {formatDate(comment?.CreatedAt)}
                                                                                    </p>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    ) : (
                                                                        <p className="text-sm text-gray-500 mt-2">No comments yet</p>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="text-sm text-gray-500">No tracking data available</p>
                                        )}

                                    </div>
                                )}
                                {expandedJob === req?._id && (
                                    <div className="p-6 border-t space-y-4 bg-gray-50">
                                        {IsQuotationLoading ? (
                                            <p className="text-gray-500 text-sm">Loading Quotation...</p>
                                        ) : Quotation && Quotation?.length > 0 ? (
                                            <>
                                                {Quotation.map((qtn) => (
                                                    <div
                                                        key={qtn?._id}
                                                        className={`bg-white rounded-xl shadow-md p-4 border border-gray-200 ${qtn?.IsInvalid ? "opacity-70 cursor-not-allowed bg-gray-100" : ""
                                                            }`}
                                                    >
                                                        <h4 className="text-lg font-semibold text-gray-800 mb-3">
                                                            My Quotation / Bid
                                                        </h4>

                                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm bg-gray-50 p-3 rounded-lg border">
                                                            <div>
                                                                <span className="font-medium text-gray-600">Bid Amount:</span>{" "}
                                                                ₹{qtn?.BidAmount}
                                                            </div>
                                                            {qtn?.Note && (
                                                                <div>
                                                                    <span className="font-medium text-gray-600">Note:</span>{" "}
                                                                    {qtn?.Note}
                                                                </div>
                                                            )}
                                                            <div>
                                                                <span className="font-medium text-gray-600">Created:</span>{" "}
                                                                {new Date(qtn?.createdAt).toLocaleString()}
                                                            </div>
                                                        </div>
                                                        {!qtn?.IsInvalid && req?.Status ==='rebid' &&
                                                            <div className="mt-4 flex justify-end gap-3">
                                                                <button
                                                                    onClick={() => OpenUpdateQuotationModel(qtn)}
                                                                    disabled={qtn?.IsInvalid}
                                                                    className="flex items-center gap-1 px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
                                                                >
                                                                    <FaEdit className="text-xs" /> Update
                                                                </button>
                                                                <button
                                                                    onClick={() => OpendeleteQuotationModel(qtn)}
                                                                    disabled={qtn?.IsInvalid}
                                                                    className="flex items-center gap-1 px-3 py-1.5 bg-red-600 text-white text-sm rounded-md hover:bg-red-700 transition"
                                                                >
                                                                    <FaTrash className="text-xs" /> Delete
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>
                                                ))}
                                                {Quotation?.length > 0 && Quotation?.every((q) => q?.IsInvalid) && (
                                                    <div className="mt-4 text-center">
                                                        <button
                                                            onClick={() => OpenAddQuotationModel(req)}
                                                            className="px-4 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-700 transition"
                                                        >
                                                            + Rebid
                                                        </button>
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                )}

                            </div>
                        ))}
                    </div>
                )}
            </div>
            <ContractorAddTrackerModal
                isOpen={AddTrackerModel}
                onClose={CloseAddTrackerModel}
                fetchAllTracker={GetAllAssignRequirement}
                selectedreq={selectedreq}
            />
            <ContractorUpdateTrackerModal
                isOpen={IsUpdateTrackerOpen}
                onClose={CloseUpdateTrackerModel}
                fetchAllTracker={fetchAllTracker}
                tracker={SelectedTracker}
            />
            <ContractorDeleteTrackerModal
                isOpen={IsDeleteTrackerOpen}
                onClose={CloseDeleteTrackerModel}
                fetchAllTracker={fetchAllTracker}
                tracker={SelectedTracker}
            />
            <ContractorCreateBidModel
                SelectedReq={SelectedReq}
                isOpen={AddQuotationModel}
                onClose={CloseAddQuotationModel}
                GetAllAssignRequirement={GetAllAssignRequirement}
                setExpandedJob={setExpandedJob}
                isrebid={true}
            />
            <ContractorUpdateBidModel
                SelectedBid={SelectedQuotation}
                isOpen={UpdateQuotationModel}
                onClose={CloseUpdateQuotationModel}
                GetAllAssignRequirement={GetAllAssignRequirement}
                setExpandedJob={setExpandedJob}
            />
            <ContractorDeleteBidModel
                SelectedBid={SelectedQuotation}
                isOpen={DeleteQuotationModel}
                onClose={CloseDeleteQuotationModel}
                GetAllAssignRequirement={GetAllAssignRequirement}
                setExpandedJob={setExpandedJob}
            />


            <ImageModal />
        </div>
    );
}

export default AllAssignedConstructionRequirements;
